<template>
    <el-container>
        <el-main>
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
export default {
    name: 'HomePage',
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue